import {Component, OnInit} from '@angular/core';
import {routeAnimation} from '../../route.animation';
import {Title} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
	animations: [routeAnimation]
})

export class PageNotFoundComponent implements OnInit {

	constructor(private titleService: Title) {
	}

	ngOnInit(): void {
		this.titleService.setTitle('Pagina niet gevonden | ' + environment.webappName);
	}
}
